import { Menu } from "lucide-react";
import { Button } from "../../../shared/components/button/Button";
import { forwardRef } from "react";

const MobileMenuTrigger = forwardRef((props, ref) => {
  return (
    <Button
      {...props}
      variant="outline"
      size="icon"
      className="shrink-0 bg-background md:hidden"
      ref={ref}
    >
      <Menu className="h-5 w-5" />
      <span className="sr-only">Toggle navigation menu</span>
    </Button>
  );
});

export default MobileMenuTrigger;
